import { brand } from "../config/theme";

// Colores de estado de la lista, la tabla, las pestañas y las fichas de unidad.
// Antes había una copia en cada archivo «para que se lean como la misma cosa»;
// una sola fuente evita que una copia se desvíe. El marcador del mapa
// (MapView, VehiclePointer) usa tonos más fuertes a propósito y no sale de aquí.
export const UNIT_STATUS_COLORS = {
  driving: brand.primary,
  ralenti: "#fbbf24",
  stopped: "#f87171",
  offline: "#9ca3af",
} as Record<string, string>;

// Antes los cuatro estados del motor estaban definidos con el MISMO verde
// (#009804): un motor apagado se veía encendido.
export const ENGINE_COLORS = { on: "#22C55E", off: "#EF4444", unknown: "#F59E0B", noData: "#9CA3AF" };
